<template>
  <div v-sticky="active"
       class="sticky-top-bar"
       on-stick="onStick"
       sticky-offset="offset"
       :sticky-z-index="zIndex"
       ref="stickyTopBar"
       sticky-side="0">
    <div class="sticky-top-bar__background" :style="stickyTopBarBackgroundStyle"/>
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'StickyTopBar',
  props: {
    parentContainerSelector: {
      type: String,
      required: true
    },
    offset: {
      type: Object,
      default: () => ({ top: 65 })
    },
    active: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      parentContainerOffsetLeft: 0
    }
  },
  watch: {
    'offset.top' (newValue) {
      this.$nextTick(() => {
        if (!this.$refs.stickyTopBar['@@vue-sticky-directive']) { return }
        this.$refs.stickyTopBar['@@vue-sticky-directive'].options.topOffset = newValue
      })
    }
  },
  computed: {
    stickyTopBarBackgroundStyle() {
      return {
        left: `-${this.parentContainerOffsetLeft}px`,
        width: `calc(100% + ${this.parentContainerOffsetLeft * 2}px)`,
      }
    }
  },
  mounted () {
    this.setEventListeners()
    this.calculateParentContainerOffsetLeft()
  },
  beforeDestroy() {
    this.removeEventListeners()
  },
  methods: {
    setEventListeners () {
      this.$root.$on('calculateParentContainerOffsetLeft', () => {
        this.$nextTick(() => { this.calculateParentContainerOffsetLeft() })
      })
      window.addEventListener('resize', this.calculateParentContainerOffsetLeft)
    },
    removeEventListeners () {
      window.removeEventListener('resize', this.calculateParentContainerOffsetLeft)
    },
    calculateParentContainerOffsetLeft () {
      const container = this.parentContainerSelector ? document.querySelector(this.parentContainerSelector) : null
      const style = window.getComputedStyle(container, null)
      const margin = style.getPropertyValue('margin-left')
      const padding = style.getPropertyValue('padding-left')

      this.parentContainerOffsetLeft = Number.parseInt(margin) + Number.parseInt(padding) + 2
    },
    onStick (event) {
      if (this.active) {
        this.$refs.stickyTopBar.classList.toggle('on-top', event.sticked)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/variables";

.sticky-top-bar {
  // z-index: 16;

  &.on-top {
    background-color: white;

    .sticky-top-bar__background {
      top: -1px;
      height: 100%;
      position: absolute;
      background-color: white;
      width: 100%;
      z-index: -1;
      box-shadow: 10px 6px 12px rgba(0, 0, 0, 0.059);
      border: 1px solid $border-line;
      box-sizing: border-box;
    }
  }
}
</style>